// extracted by mini-css-extract-plugin
export default {"container":"FollowUs_container__jBBjk","list":"FollowUs_list__L+lPf","item":"FollowUs_item__JYN7M","soc_icon":"FollowUs_soc_icon__Svwt7"};